import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select';
import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {URL} from '../../util/ambienteActions';
import {cadastrarPreco} from '../../actions/preco/cadastrarPreco'
import buscarPrecos from '../../actions/preco/buscarPrecos';
import alterarPreco from '../../actions/preco/alterarPreco'
import recuperarValorPrecoIdaVolta from '../../actions/preco/recuperarValorIdaVolta';
import {maxValueMonetario, renderFieldMonetarioLabelEncima, required, renderFieldCheck} from '../../util/inputs';
import $ from 'jquery'

import {estados} from '../../util/constantsUtil';
import {showSuccessMsg} from '../../util/messagesUtil';

export const validate = (values) => {
    const errors = {};
    if (!values.cidadeOrigem) {
        errors.cidadeOrigem = 'Campo obrigatório'
    }
    if (!values.cidadeDestino) {
        errors.cidadeDestino = 'Campo obrigatório'
    }
    if (!values.preco) {
        errors.preco = 'Campo obrigatório'
    }
    if (!values.duracao) {
        errors.duracao = 'Campo obrigatório'
    }

    return errors
};

const renderField = ({
                         input,
                         label,
                         type,
                         css,
                         max,
                         cod,
                         readOnly,
                         meta: {touched, error}
                     }) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                   className={css}
                   maxLength={max}
                   style={{borderColor: touched && error ? 'red' : ''}}
                   disabled={readOnly || cod}
                   readOnly={readOnly}/>
            {touched
            && (error && <span style={{color: 'red'}}>{error}</span>)}
        </div>
    </div>
);

const ModalConfirmarAlterarPreco = ({precoRecuperado, fecharModal, cadastrarAlterarPrecoIdaVolta, state, props, limparCampos}) => {
    return <div className="modal confirmar" id="modalConfirmarAlterarPreco" tabIndex="-1" role="dialog"
    aria-labelledby="modalConfirmacao" aria-hidden="true" data-backdrop="static">
        {precoRecuperado ?
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">info</span>
                        Confirmar Alteração
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff' }}>
                    {precoRecuperado.valorVolta != null && precoRecuperado.valorIda == null ?
                    <p>Já existe cadastrado para esse tipo de veículo o valor <strong>R${precoRecuperado.valorVolta}</strong> para a <b>VOLTA</b>.
                        Deseja aplicar a alteração na <b>VOLTA</b> e criar a <b>IDA</b>?</p> : ''}

                    {precoRecuperado.valorVolta == null && precoRecuperado.valorIda != null ?
                    <p>Já existe cadastrado para esse tipo de veículo o valor <strong>R${precoRecuperado.valorIda}</strong> para a <b>IDA</b>.
                        Deseja aplicar a alteração na <b>IDA</b> e criar a <b>VOLTA</b>?</p> : ''}

                    {precoRecuperado.valorVolta != null && precoRecuperado.valorIda != null ?
                    <p>Já existe cadastrado para esse tipo de veículo o valor <strong>R${precoRecuperado.valorIda}</strong> para a <b>IDA</b>{' '}
                        e o valor <strong>R${precoRecuperado.valorVolta}</strong> para a <b>VOLTA</b>.<br/>
                        Deseja aplicar a alteração na <b>IDA</b> e na <b>VOLTA</b>?</p> : ''}
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar"
                            onClick={() => fecharModal()}>Cancelar
                    </button>
                    <button type="button" className="vx-modal-btn-confirmar"
                            onClick={() => cadastrarAlterarPrecoIdaVolta(limparCampos, state, props, fecharModal)}>
                        <span className="material-icons" style={{ fontSize: 15 }}>save</span>
                        Alterar
                    </button>
                </div>
            </div>
        </div> : ''}
    </div>};

export class ModalCadastrarPreco extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.handleEstadoOrigem = this.handleEstadoOrigem.bind(this);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.props.changeFieldValue('formularioCadastroPreco', 'habilitadoPrecoVolta',
            this.props.habilitadoPrecoVolta
        )
        this.state = {
            usuario: null,
            marcacaoLida: false,
            tiposQualificacao: [],
            cidadeOrigem: [],
            cidadeDestino: [],
            tipos: [],
            estadoOrigemSelecionado: '',
            estadoDestinoSelecionado: '',
            tipoPreco: '',
            cidadeDestinoSelecionada: '',
            cidadeOrigemSelecionada: '',
            valor: null,
            valorAntt: null,
            tarifaSeguro: null,
            habilitadoPrecoVolta: this.props.habilitadoPrecoVolta
        }
    }

    abrirModalConfirmarAlteracao() {
        $('#modalConfirmarAlterarPreco').modal('show');
    }

    fecharModalConfirmarAlteracao() {
        $('#modalConfirmarAlterarPreco').modal('hide');
    }

    exibirComboTipoVeiculo(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione um tipo...'
                    options={this.props.tiposPreco.map(elemento => ({
                        label: elemento.descricaoTipoPreco,
                        value: elemento.tipoPreco
                    }))}
                    onChange={value => {event.input.onChange(value)
                                    this.setState({tipoPreco: value})}}
                    onBlur={() => event.input.onBlur()}
                    isDisabled={this.props.idPreco}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    componentDidMount() {
        if (this.props.tipo) {
            this.setState({tipoveiculoSelecionado: this.props.tipo})
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.habilitadoPrecoVolta !== this.props.habilitadoPrecoVolta) {
            this.setState({ habilitadoPrecoVolta: this.props.habilitadoPrecoVolta });
        }
    }

    buscarPrecos() {
        this.props.buscarPrecos(this.props.empresaSelecionada.id, this.props.parametros, this.props.paginaAtual, this.props.registrosPorPagina);
    }

    cadastrarPrecoIdaVolta(values) {
        const parametrosPreco = {
            id: values.idPreco,
            cidadeOrigemId: values.cidadeOrigem.value,
            cidadeDestinoId: values.cidadeDestino.value,
            empresaId: this.props.empresaSelecionada.id,
            tipoPreco: values.tipo.value
        }
        
        this.props.recuperarValorPrecoIdaVolta(parametrosPreco).then(() => {
            if(this.props.precoRecuperado.valorIda || this.props.precoRecuperado.valorVolta) {
                this.abrirModalConfirmarAlteracao();
            } else {
                this.props.cadastrarPreco(this.props.montarParametroPreco(values)).then((resp) => {
                    if (resp.payload.status === 200) {
                        showSuccessMsg('Valor cadastrado com sucesso');
                        this.limparCampos();
                        this.buscarPrecos();
                    }
                })
            }
        })
    }

    cadastrarAlterarPrecoIdaVolta(limparCampos, state, props, fecharModal) {
        const values = {
            idPreco: props.idPreco ? props.idPreco : null,
            cidadeDestino: state.cidadeDestinoSelecionada ? state.cidadeDestinoSelecionada : props.cidadeDestino,
            cidadeOrigem: state.cidadeOrigemSelecionada ? state.cidadeOrigemSelecionada : props.cidadeOrigem,
            habilitadoPrecoVolta: state.habilitadoPrecoVolta,
            tarifaSeguro: state.tarifaSeguro ? state.tarifaSeguro : props.tarifaSeguro,
            tipo: state.tipoPreco ? state.tipoPreco : props.tipoPreco,
            valor: state.valor ? state.valor : props.valor,
            valorAntt: state.valorAntt ? state.valorAntt : props.valorAntt
        }
        
        props.cadastrarPreco(props.montarParametroPreco(values)).then((resp) => {
            if (resp.payload.status === 200) {
                showSuccessMsg('Valor cadastrado com sucesso');
                limparCampos();
                props.buscarPrecos(props.empresaSelecionada.id, props.filtrosAdicionadosPreco, props.paginaAtual, props.registrosPorPagina);
                fecharModal();
            }
        })
    }

    submit(values) {
        const habilitadoPrecoVolta = values.habilitadoPrecoVolta;
 
        if(this.props.idPreco) {
            this.props.alterarPreco(this.props.montarParametroPreco(values)).then(() => {
                showSuccessMsg('Valor atualizado com sucesso');
                this.buscarPrecos();
            });
        } else if (habilitadoPrecoVolta) {
            this.cadastrarPrecoIdaVolta(values);
        } else {
            this.props.cadastrarPreco(this.props.montarParametroPreco(values)).then((resp) => {
                if (resp.payload.status === 200) {
                    showSuccessMsg('Valor cadastrado com sucesso');
                    this.limparCampos();
                    this.buscarPrecos();
                }
            })
        }
    }

    limparFormulario() {
        this.props.reset('formularioCadastroPreco');
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroPreco',
            'cidadeDestino', '');
        this.props.changeFieldValue('formularioCadastroPreco',
            'valor', '');
    }

    handleEstadoOrigem = (estado) => {
        const url = `${URL}/public/cidades/${estado.value}`;
        this.props.changeFieldValue('formularioCadastroPreco',
            'cidadeDestino', '');
        axios.get(url, SLOW_REQUEST_CONFIG).then((response) => {
            if (response != null) {
                this.setState({cidadeOrigem: response.data, estadoOrigemSelecionado: estado})
            }
        })
    };

    handleEstadoDestino = (estado) => {
        const url = `${URL}/public/cidades/${estado.value}`;
        this.props.changeFieldValue('formularioCadastroPreco',
            'cidadeDestino', '');
        axios.get(url, SLOW_REQUEST_CONFIG).then((response) => {
            if (response != null) {
                this.setState({cidadeDestino: response.data, estadoDestinoSelecionado: estado})
            }
        })
    };

    exibirComboEstadoOrigem(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione a origem...'
                    value={this.state.estadoOrigemSelecionado}
                    options={estados.map(elemento => ({label: `${elemento.nome}-${elemento.uf}`, value: elemento.uf}))}
                    onChange={value => this.handleEstadoOrigem(value)}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirComboCidadeOrigem(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione uma cidade...'
                    options={this.state.cidadeOrigem.map(elemento => ({
                        label: `${elemento.nome}-${elemento.uf}`,
                        value: elemento.id
                    }))}
                    onChange={value => {event.input.onChange(value)
                        this.setState({cidadeOrigemSelecionada: value})}}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }


    exibirComboCidadeDestino(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione uma cidade...'
                    options={this.state.cidadeDestino.map(elemento => ({
                        label: `${elemento.nome}-${elemento.uf}`,
                        value: elemento.id
                    }))}
                    onChange={value => {event.input.onChange(value)
                        this.setState({cidadeDestinoSelecionada: value})}}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirComboEstadoDestino(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione o estado destino...'
                    value={this.state.estadoDestinoSelecionado}
                    options={estados.map(elemento => ({label: `${elemento.nome}-${elemento.uf}`, value: elemento.uf}))}
                    onChange={value => this.handleEstadoDestino(value)}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        return (
            <div className="modal fade show" id="modalCadastrarPreco" role="dialog"
                 aria-labelledby="modalCadastrarPreco" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                        <div className="vx-modal-header">
                            <div className="vx-modal-title">
                                <span className="material-icons">{this.props.idPreco ? 'edit' : 'add'}</span>
                                {this.props.idPreco ? 'Editar Preço' : 'Novo Valor'}
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparCampos}>
                                <span className="material-icons">close</span>
                            </button>
                        </div>
                        <div className="vx-modal-body" style={{ background: '#fff' }}>
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-6">
                                                <label>Estado de origem</label>
                                                <Field name='estadoOrigem'
                                                       component={this.exibirComboEstadoOrigem.bind(this)}/>
                                            </div>
                                            <div className="col-12 col-sm-9 col-md-6">
                                                <label>Cidade de origem</label>
                                                <Field name='cidadeOrigem'
                                                       component={this.exibirComboCidadeOrigem.bind(this)}/>
                                            </div>
                                        </div>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-6">
                                                <label>Estado de destino</label>
                                                <Field name='estadoDestino'
                                                       component={this.exibirComboEstadoDestino.bind(this)}/>
                                            </div>
                                            <div className="col-12 col-sm-9 col-md-6">
                                                <label>Cidade de destino</label>
                                                <Field name='cidadeDestino'
                                                       component={this.exibirComboCidadeDestino.bind(this)}/>
                                            </div>
                                        </div>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-6">
                                                <label>Tipo veículo</label>
                                                <Field name='tipo'
                                                       component={this.exibirComboTipoVeiculo.bind(this)}/>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div>
                                                <Field name="valor" validate={[required, maxValueMonetario]}
                                                       component={renderFieldMonetarioLabelEncima}
                                                       label="Valor da viagem"
                                                       onBlur={(e) => this.setState({valor: e.target.value})}/>
                                            </div>
                                            <div className='mt-1 ml-3'>
                                                <label className='mt-4'/>
                                                <Field name='habilitadoPrecoVolta' type="checkbox" component={renderFieldCheck}
                                                       label="Criar ou editar a volta"
                                                       css="form-check-input"
                                                       checked={this.state.habilitadoPrecoVolta}
                                                       onBlur={(e) => this.setState({habilitadoPrecoVolta: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div>
                                                <Field name="valorAntt" validate={[maxValueMonetario]}
                                                       component={renderFieldMonetarioLabelEncima}
                                                       label="Valor da ANTT"
                                                       onBlur={(e) => this.setState({valorAntt: e.target.value})}/>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div>
                                                <Field name="tarifaSeguro" validate={[maxValueMonetario]}
                                                       component={renderFieldMonetarioLabelEncima}
                                                       label="Tarifa do Seguro"
                                                       onBlur={e => this.setState({tarifaSeguro: e.target.value})}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group area-codigo">
                                    <Field name="idPreco" type="hidden" component={renderField}
                                           css="form-control col-md-12"/>
                                </div>
                                <div className="vx-modal-footer">
                                    <button type="submit" disabled={invalid || submitting || pristine}
                                            className="vx-modal-btn-confirmar">
                                        <span className="material-icons" style={{ fontSize: 15 }}>save</span>
                                        Salvar
                                    </button>
                                </div>
                                <ModalConfirmarAlterarPreco limparCampos={this.limparCampos} props={this.props} state={this.state}
                                    precoRecuperado={this.props.precoRecuperado} fecharModal={this.fecharModalConfirmarAlteracao} cadastrarAlterarPrecoIdaVolta={this.cadastrarAlterarPrecoIdaVolta}/>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        idPreco: formValueSelector('formularioCadastroPreco')(state, 'idPreco'),
        cidadeOrigem: formValueSelector('formularioCadastroPreco')(state, 'cidadeOrigem'),
        cidadeDestino: formValueSelector('formularioCadastroPreco')(state, 'cidadeDestino'),
        trechos: formValueSelector('formularioCadastroPreco')(state, 'trechos'),
        tipoPreco: formValueSelector('formularioCadastroPreco')(state, 'tipo'),
        tarifaSeguro: formValueSelector('formularioCadastroPreco')(state, 'tarifaSeguro'),
        valorAntt: formValueSelector('formularioCadastroPreco')(state, 'valorAntt'),
        valor: formValueSelector('formularioCadastroPreco')(state, 'valor'),
        empresaSelecionada: state.empresaSelecionada,
        filtrosAdicionadosPreco: state.filtrosAdicionadosPreco,
        tiposPreco: state.tiposPreco,
        paginaAtual: state.paginaAtualPreco,
        registrosPorPagina: state.registrosPorPaginaPreco,
        precoRecuperado: state.precoRecuperado

    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarPreco,
        buscarPrecos,
        alterarPreco,
        recuperarValorPrecoIdaVolta
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroPreco',
    validate
})(ModalCadastrarPreco));
